import { Component, Input, OnInit } from '@angular/core'
import { PageService } from '../../page/page.service'
import { ProgressService } from './progress.service'
import { ProgressModel } from './progress.model'

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html'
})
export class ProgressComponent implements OnInit {
  ajax: any
  @Input() model: ProgressModel
  @Input() ido: string
  constructor(private pservice: PageService, private service: ProgressService) { }

  ngOnInit() {
    this.pservice.components.progresses.push({ service: this.service, model: this.model })
    if (this.ido) {
      this.model = new ProgressModel()
      this.model.id = this.ido
    }
  }

  ngAfterViewInit() {
    if (this.ido)
      this.ajax.Execute({
        url: 'progress/get',
        data: { id: this.ido },
        success: (post) => {
          this.service.modifier(post.result)
          this.model = post.result[0]
          // this.service.init(this.model)
        }
      })
    // else
      // this.service.init(this.model)
  }

}
